import IconBullet from './IconBullet';

export default IconBullet;
